import type { TranslationMessages } from '../types';

export const warehouses: TranslationMessages = {
      name: 'Kho hàng |||| Kho hàng',
      add: 'Thêm kho hàng',
      create: 'Tạo kho hàng',
      edit: 'Chỉnh sửa kho hàng',
      delete: {
        title: 'Xóa kho hàng',
        description:
          'Bạn có chắc chắn muốn xóa kho hàng này? Hành động này không thể hoàn tác.',
      },
      list: 'Danh sách kho hàng',
      search: 'Tìm kiếm kho hàng...',
      empty: 'Chưa có kho hàng nào',
      form: {
        basicInfo: 'Thông tin cơ bản',
        location: 'Vị trí',
        name: 'Tên',
        description: 'Mô tả',
        address: 'Địa chỉ',
        additionalAddressInfo: 'Thông tin địa chỉ bổ sung',
        contact: 'Liên hệ',
        latitude: 'Vĩ độ',
        longitude: 'Kinh độ',
        createDescription: 'Tạo kho hàng mới',
        editDescription: 'Cập nhật thông tin kho hàng',
        required: 'Vui lòng điền đầy đủ các trường bắt buộc',
        locationRequired: 'Vui lòng cung cấp tọa độ vị trí',
        error: 'Không thể lưu kho hàng',
      },
      fields: {
        address: 'Địa chỉ',
        additionalAddressInfo: 'Thông tin địa chỉ bổ sung',
        contact: 'Liên hệ',
        description: 'Mô tả',
        location: 'Vị trí',
        name: 'Tên',
        picture: 'Hình ảnh',
        lat: 'Vĩ độ',
        lng: 'Kinh độ',
        pictures: 'Hình ảnh kho hàng',
      },
      fieldGroups: {
        identity: 'Nhận dạng',
      },
      validation: {
        invalidLatitude: 'Vĩ độ không hợp lệ',
        invalidLongitude: 'Kinh độ không hợp lệ',
      },
    };
